// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClosingAccountSearchDealer from '../../state/closing-account-search-account';
import DealerSearchModal from '../closing-account/dealer-search-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import NewTransferDealerDetails from '../../../../product/new-transfer/components/new-transfer-dealer-details';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {stripSpaces} from '../../../../shared/services/strip-spaces';

function handleChange(event) {

    const processedValue = stripSpaces(event.target.value);

    this.onAccountLookupChange(processedValue, this.index);

}

function handleKeyPress(event) {

    if (event.key === 'Enter' || event.key === 'Tab') {

        const processedValue = stripSpaces(event.target.value);

        this.onAccountLookupBlur(processedValue, this.index);

    }

}

function handleClick(overrideAccount) {

    this.updateOverrideAccount(overrideAccount);

}

function handleDealerSearchClick() {

    this.onDealerSearchViewClick(this.index);

}

function handleResetClick() {

    this.onResetClick(this.index);

}

const ClosingAccountDetails = (props, context) =>

    <section>
        <main>
            <div className='account-group'>
                <div className='data-pairs'>
                    <LabeledString
                        className='business_endDate'
                        data={buildDate(props.closingAccountChanges.businessEndDate)}
                        label='BUSINESS_END'
                    />
                </div>
                <div className='data-pairs'>
                    <LabeledString
                        className='account_endDate'
                        data={buildDate(props.closingAccountChanges.accountEndDate)}
                        label='ACCOUNT_END'
                    />
                </div>

                <div className='data-pairs'>

                    <LabeledString
                        className='new-account'
                        data={buildDealer(props.closingAccountChanges.newAccount, context.user.settings.dealer.displayFormat.key)}
                        label='NEW_ACCOUNT'
                    />
                </div>
                { props.closingAccountChanges.status === 'NEW' &&
                <div className='data-pairs'>
                    <span className='override-account'>
                        <FormattedMessage
                            id='OVERRIDE_SUGGESTED_ACCOUNT'
                        />
                    </span>
                    {props.closingAccountChanges.overrideAccount.account ? <NewTransferDealerDetails dealer={props.closingAccountChanges.overrideAccount}/> : null}
                </div>
                }
            </div>

            <div className='dealer-search-link'>
                {
             props.closingAccountChanges.overrideAccount.account ?
                 <span
                     className='icon-search'
                     onClick={props::handleResetClick}
                 /> :
                props.closingAccountChanges.status === 'NEW' &&
                    (<div className='dealer-search-controls'>
                        <input
                            className='dealer-search-input'
                            onChange={props::handleChange}
                            onKeyDown={props::handleKeyPress}
                            type='text'
                            value={props.closingAccountChanges.accountLookup}
                        />
                        <span className='dealer-search-or'><FormattedMessage id='OR'/></span>
                        <button
                            className='dealer-search-button'
                            onClick={props::handleDealerSearchClick}
                        >
                            <span className='icon-search-small'/>
                            <FormattedMessage id='DEALER_SEARCH'/>
                        </button>
                    </div>)
                    }
                {props.index === 0 ?
                    <DealerSearchModal
                        isOpen={props.dealerSearchModal}
                        onClose={props.onCloseClick}
                        onDealerSelect={props::handleClick}
                    /> : null
                }
            </div>
        </main>
    </section>;

ClosingAccountDetails.displayName = 'ClosingAccountDetails';
ClosingAccountDetails.propTypes = {
    closingAccountChanges: PropTypes.instanceOf(ClosingAccountSearchDealer).isRequired,
    dealerSearchModal: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    onAccountLookupBlur: PropTypes.func.isRequired,
    onAccountLookupChange: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func,
    onDealerSearchViewClick: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired,
    updateOverrideAccount: PropTypes.func.isRequired
};
ClosingAccountDetails.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ClosingAccountDetails;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/closing-account/closing-account-details.js